export default "__VITE_ASSET__DC1Q6gS0__"